var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monthlyServiceCharge"},[_c('v-row',[_c('v-col',[_c('breadcrumb',{attrs:{"items":_vm.breadcrumbs}})],1)],1),_c('monthly-service-charge-table',{attrs:{"monthly-service-charge-url":_vm.monthlyServiceChargeUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }